import * as React from 'react';
export function useMediaQuery(query, defaultValue) {
    const subscribe = React.useCallback((callback) => {
        const matchMedia = window.matchMedia(query);
        matchMedia.addEventListener('change', callback);
        return () => {
            matchMedia.removeEventListener('change', callback);
        };
    }, [query]);
    const getSnapshot = () => {
        return window.matchMedia(query).matches;
    };
    const getServerSnapshot = () => {
        return typeof window !== 'undefined' ? window.matchMedia(query).matches : defaultValue;
    };
    return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
